export function bindPurchase(form) {
  const select=form.querySelector('[name="id"]');
  const button=form.querySelector('[data-purchase-button]');
  const status=form.querySelector('[data-purchase-status]');
  const price=form.closest('.product-info').querySelector('.price');
  const update=()=>{
    const option=select.selectedOptions[0];
    const open=button.dataset.ordersOpen==='true';
    button.disabled=!open||option?.dataset.available!=='true';
    button.textContent=!open?button.dataset.closedLabel:button.disabled?button.dataset.soldOutLabel:button.dataset.addLabel;
    status.textContent=option?.textContent||'';
    if(option)price.textContent=option.dataset.price;
  };
  select.addEventListener('change',()=>{
    update();
    const url=new URL(location.href);
    url.searchParams.set('variant',select.value);
    history.replaceState(history.state,'',url);
  });
  form.addEventListener('submit',event=>{
    update();
    if(button.disabled||!form.checkValidity())event.preventDefault();
  });
  update();
}
if(typeof document!=='undefined')document.querySelectorAll('.tco-product-form').forEach(bindPurchase);
